import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function LanguageSwitcher({ compact = false }) {
  const { language, setLanguage } = useLanguage();

  if (compact) {
    return (
      <label className="inline-flex items-center gap-2 text-xs font-medium text-slate-500">
        <span>Lang</span>
        <select
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          className="h-10 rounded-lg border border-slate-700/80 bg-slate-900/80 px-2.5 text-xs font-semibold text-slate-200 outline-none transition hover:border-slate-600 focus:border-brand-400/80 focus:ring-2 focus:ring-brand-500/25"
          aria-label="Language"
        >
          <option value="fr">FR</option>
          <option value="en">EN</option>
        </select>
      </label>
    );
  }

  return (
    <label className="inline-flex items-center gap-2 text-xs font-medium text-slate-500">
      <span>Lang</span>
      <select
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
        className="ui-select h-10 rounded-lg px-3 text-xs font-semibold"
        aria-label="Language"
      >
        <option value="fr">FR</option>
        <option value="en">EN</option>
      </select>
    </label>
  );
}

